import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import tooltips from '../constants/tooltips.json'

const EditorFooter = (props) => {
  const {
    showTooltips
  } = props
  return (
    <div className={classnames("editor-footer", { "device-connected": props.deviceConnected }, { 'updating': props.updatingFirmware})}>
      <div
        className="connection-status"
        data-tip={tooltips['device_connection']}
        data-multiline="true"
        data-place="top"
        data-tip-disable={!showTooltips}
      >{props.connectionStatus}</div>
      <a href="https://keithmcmillen.com" target="_blank" rel="noopener noreferrer" 
        className="kmi-logo"
        data-tip={tooltips['website']}
        data-multiline="true"
        data-place="top"
        data-tip-disable={!showTooltips}
      > </a>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    deviceConnected: state.device.connected,
    updatingFirmware: state.device.updatingFirmware,
    connectionStatus: state.editor.status,
    showTooltips: state.editorPreferences.showTooltips
  }
}

export default connect(mapStateToProps, null)(EditorFooter)
